import React from 'react';
import { DropDownTree } from "@progress/kendo-react-dropdowns";

function ChatContextDropdown({
    treeOptions,
    treeValue,
    subTreeOptions,
    subTreeValue,
    loading,
    handleExpandChange,
    handleChange,
    handleSubTreeExpandChange,
    handleSubTreeChange
}) {
    return (
        <div>
            <div className='font-medium txt-secondary fw-medium'>
                Set context to:
            </div>
            <div>
                <DropDownTree
                    className="border"
                    style={{ width: "300px" }}
                    data={treeOptions}
                    value={treeValue}
                    textField="name"
                    expandField="isExpanded"
                    subItemsField="children"
                    selectField="isSelected"
                    onExpandChange={handleExpandChange}
                    onChange={handleChange}
                    disabled={loading}
                />
                <style>
                    {
                        `.k-input-inner {
                            font-size: 14px !important;
                            font-weight: 400 !important;
                            color: rgba(28, 44, 73, 0.95) !important;
                        }`
                    }
                </style>
                &nbsp;
                {treeValue && treeValue.type !== "portal" && treeValue.name !== "Portals" && (
                    <DropDownTree
                        className="border"
                        style={{ width: "250px" }}
                        data={subTreeOptions}
                        value={subTreeValue}
                        textField="name"
                        expandField="isExpanded"
                        subItemsField="children"
                        selectField="isSelected"
                        onExpandChange={handleSubTreeExpandChange}
                        onChange={handleSubTreeChange}
                        disabled={loading}
                    />
                )}
            </div>
        </div>
    );
}

export default ChatContextDropdown;
